// /home/w3d/web3reg-com/src/pages/LandingPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faUniversity, faGlobe, faChartLine, faComments, faLock, faPaperPlane, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import DemoTweet from '../components/DemoTweet';
import GlobalNav from '../components/GlobalNav';
import Footer from '../components/Footer';

const LandingPage = () => {
  const scrollToMyUrl = (e) => {
    e.preventDefault();
    const element = document.getElementById('myurl');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToZhat = (e) => {
    e.preventDefault();
    const element = document.getElementById('zhat');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="landing-page">
      {/* ADD GlobalNav HERE - Right at the top of the page */}
      <GlobalNav />
      
      {/* Web3 Logo at the Top - Centered */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '3rem',
        paddingBottom: '1rem',
        background: 'linear-gradient(to bottom, var(--black) 0%, rgba(255,215,0,0.05) 100%)',
        borderBottom: '2px solid var(--gold)'
      }}>
        <img 
          src="/web3.png" 
          alt="Web3 Logo" 
          style={{ 
            width: '183px',
            height: '175px',
            objectFit: 'contain',
            filter: 'drop-shadow(0 8px 16px rgba(255,215,0,0.4))',
            transition: 'all 0.4s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.filter = 'drop-shadow(0 12px 24px rgba(255,215,0,0.6))';
            e.currentTarget.style.transform = 'scale(1.05) rotate(2deg)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.filter = 'drop-shadow(0 8px 16px rgba(255,215,0,0.4))';
            e.currentTarget.style.transform = 'scale(1) rotate(0deg)';
          }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />
      </div>

      {/* Hero Section */}
      <section className="hero">
        <div className="container" style={{ maxWidth: '900px' }}>
          <h1 className="gold-logo" style={{ fontSize: '4rem', marginBottom: '1rem' }}>
            The Rise of Decentralized Web
          </h1>
          <h2 style={{ fontSize: '2rem', color: 'var(--gold)', marginBottom: '2rem' }}>
            BankSystem : Social Media : Messaging : Domains : All on BlockChain
          </h2>
          <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto 2rem' }}>
            Welcome to Web3Reg - your gateway to decentralized identity, social media, banking, and secure messaging. 
            Experience true ownership in the Web3 era.
          </p>
          <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="https://banksystem.co" target="_blank" rel="noopener noreferrer" className="btn btn-gold">
              <FontAwesomeIcon icon={faUniversity} /> BankSystem
            </a>
            <a href="https://zpost.ai" target="_blank" rel="noopener noreferrer" className="btn btn-gold">
              <FontAwesomeIcon icon={faComments} /> Zpost Social
            </a>
            <a href="#zhat" onClick={scrollToZhat} className="btn btn-gold">
              <FontAwesomeIcon icon={faPaperPlane} /> Zhat Messenger
            </a>
          </div>
        </div>
      </section>

      {/* Zpost.ai Section */}
      <section className="how-it-works" style={{ padding: '4rem 2rem', background: 'linear-gradient(135deg, var(--black) 0%, rgba(255,215,0,0.05) 100%)' }}>
        <div className="container">
          <div className="cards" style={{ display: 'flex', alignItems: 'center', gap: '3rem', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ flex: 1 }}>
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div className="gold-logo" style={{ fontSize: '2.5rem' }}>Zpost.ai</div>
                  <span style={{ color: 'var(--gold)', fontWeight: 'bold', background: 'rgba(255,215,0,0.1)', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem' }}>
                    Social Media
                  </span>
                </div>
                <h2 style={{ fontSize: '2.8rem', color: 'var(--text-light)', marginBottom: '1.5rem', lineHeight: '1.2' }}>
                  The Future of Free Speech is Here
                </h2>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '2rem' }}>
                  Start by creating your secure Zwallet, then claim your self-sovereign <span style={{ color: 'var(--gold)', fontWeight: 'bold' }}>.zpost.eth</span> identity.
                  No algorithms. No censorship. Just your voice, on your terms.
                </p>
                <div style={{ background: 'rgba(255,215,0,0.05)', padding: '1.5rem', borderRadius: '12px', border: '1px solid var(--border)', marginBottom: '2rem' }}>
                  <h3 style={{ color: 'var(--gold)', marginBottom: '1rem' }}>Features:</h3>
                  <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem' }}>
                    <li>ENS-gated access with .zpost.eth domains</li>
                    <li>Military-grade embedded Zwallet security</li>
                    <li>True ownership of your content and identity</li>
                    <li>Censorship-resistant decentralized platform</li>
                    <li>Your profile data on Ethereum via ENS</li>
                  </ul>
                </div>
              </div>
              <a href="https://zpost.ai" target="_blank" rel="noopener noreferrer" className="btn btn-gold" style={{ padding: '1rem 2.5rem', fontSize: '1.1rem', fontWeight: 'bold' }}>
                <FontAwesomeIcon icon={faExternalLinkAlt} style={{ marginRight: '0.5rem' }} />
                Launch Zpost.ai
              </a>
            </div>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <DemoTweet />
            </div>
          </div>
        </div>
      </section>

      {/* ZHAT MESSENGER SECTION - FIXED WITH SURGICAL PRECISION */}
      <section id="zhat" className="zhat-section" style={{ 
        padding: '4rem 2rem', 
        background: 'linear-gradient(135deg, var(--card-bg) 0%, rgba(128,0,0,0.1) 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto 4rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <div className="gold-logo" style={{ fontSize: '3.5rem' }}>Zhat</div>
              <span style={{ 
                color: 'var(--gold)', 
                fontWeight: 'bold', 
                background: 'rgba(128,0,0,0.3)', 
                padding: '0.5rem 1.5rem', 
                borderRadius: '20px', 
                fontSize: '1rem',
                border: '1px solid var(--gold)',
                boxShadow: '0 4px 12px rgba(255,215,0,0.2)'
              }}>
                Secure Messenger
              </span>
            </div>
            <h2 style={{ fontSize: '2.8rem', color: 'var(--text-light)', marginBottom: '1.5rem', lineHeight: '1.2' }}>
              Decentralized ENS-to-ENS Messaging
            </h2>
            <p style={{ fontSize: '1.1rem', color: 'var(--text-secondary)', lineHeight: '1.6', maxWidth: '700px', margin: '0 auto 2rem' }}>
              Chat securely with any ENS domain holder. No servers, no middlemen, just peer-to-peer encrypted messages.
              Built on Web3 principles for complete privacy and ownership of your conversations.
            </p>
          </div>

          {/* Three Column Layout: Image | Text | Image */}
          <div className="zhat-showcase" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '3rem', 
            maxWidth: '1400px', 
            margin: '0 auto',
            flexWrap: 'wrap'
          }}>
            {/* Left Image - john1.png */}
            <div style={{ flex: 1, minWidth: '300px', textAlign: 'center' }}>
              <div style={{ 
                background: 'linear-gradient(135deg, var(--card-bg) 0%, rgba(0,0,0,0.5) 100%)', 
                border: '3px solid var(--gold)', 
                borderRadius: '15px', 
                padding: '1rem', 
                boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 30px rgba(255,215,0,0.3)',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Golden frame effect */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  border: '1px solid rgba(255,215,0,0.3)',
                  borderRadius: '12px',
                  pointerEvents: 'none',
                  zIndex: 2
                }}></div>
                
                {/* Image Container - EXACTLY LIKE MyUrl SECTION */}
                <div style={{ 
                  width: '500px', 
                  maxWidth: '100%',
                  height: '375px',
                  maxHeight: '375px',
                  borderRadius: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto', 
                  overflow: 'hidden', 
                  position: 'relative',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  border: '2px solid var(--gold)',
                  boxShadow: '0 8px 24px rgba(255,215,0,0.2)'
                }}>
                  {/* John Connor Image - EXACT SAME STYLE AS MyUrl SECTION */}
                  <img 
                    src="/john1.png" 
                    alt="John Connor Zhat Interface" 
                    style={{ 
                      width: '500px',
                      height: '375px',
                      objectFit: 'contain', // CRITICAL: Same as MyUrl section
                      borderRadius: '10px',
                    }} 
                  />
                </div>
                
                {/* Image caption */}
                <div style={{ 
                  marginTop: '1.5rem',
                  padding: '1rem',
                  background: 'rgba(0,0,0,0.7)',
                  borderRadius: '8px',
                  border: '1px solid var(--border)'
                }}>
                  <h4 style={{ color: 'var(--gold)', marginBottom: '0.5rem', fontSize: '1.1rem' }}>
                    <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: '0.5rem' }} />
                    Send Messages
                  </h4>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                    Instant encrypted messaging to any ENS domain
                  </p>
                </div>
              </div>
            </div>

            {/* Center Text Content */}
            <div style={{ flex: 1.2, minWidth: '300px', textAlign: 'center' }}>
              <div style={{ 
                background: 'linear-gradient(135deg, rgba(0,0,0,0.8) 0%, var(--card-bg) 100%)', 
                border: '2px solid var(--gold)', 
                borderRadius: '20px', 
                padding: '3rem 2.5rem', 
                boxShadow: '0 25px 70px rgba(0,0,0,0.7), inset 0 1px 0 rgba(255,215,0,0.1)',
                height: '100%'
              }}>
                <div style={{ marginBottom: '2.5rem' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 1.5rem',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, var(--gold) 0%, #DAA520 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2.5rem',
                    color: 'var(--black)',
                    boxShadow: '0 8px 32px rgba(255,215,0,0.4)'
                  }}>
                    <FontAwesomeIcon icon={faComments} />
                  </div>
                  <h3 style={{ 
                    fontSize: '2.2rem', 
                    color: 'var(--text-light)', 
                    marginBottom: '1.5rem',
                    fontWeight: 'bold'
                  }}>
                    Web3 Native Messaging
                  </h3>
                </div>

                {/* Feature Grid */}
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: '1fr 1fr', 
                  gap: '1.5rem', 
                  marginBottom: '2.5rem'
                }}>
                  <div style={{ 
                    padding: '1.5rem',
                    background: 'rgba(255,215,0,0.05)',
                    borderRadius: '12px',
                    border: '1px solid var(--border)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      margin: '0 auto 1rem',
                      borderRadius: '50%',
                      background: 'rgba(255,215,0,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.2rem',
                      color: 'var(--gold)'
                    }}>
                      <FontAwesomeIcon icon={faShieldAlt} />
                    </div>
                    <h4 style={{ color: 'var(--gold)', marginBottom: '0.5rem', fontSize: '1rem' }}>
                      End-to-End Encrypted
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', margin: 0 }}>
                      Messages secured by Web3 cryptography
                    </p>
                  </div>

                  <div style={{ 
                    padding: '1.5rem',
                    background: 'rgba(255,215,0,0.05)',
                    borderRadius: '12px',
                    border: '1px solid var(--border)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      margin: '0 auto 1rem',
                      borderRadius: '50%',
                      background: 'rgba(255,215,0,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.2rem',
                      color: 'var(--gold)'
                    }}>
                      <FontAwesomeIcon icon={faLock} />
                    </div>
                    <h4 style={{ color: 'var(--gold)', marginBottom: '0.5rem', fontSize: '1rem' }}>
                      No Central Servers
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', margin: 0 }}>
                      Direct ENS-to-ENS communication
                    </p>
                  </div>
                </div>

                {/* Call to Action */}
                <div style={{ marginTop: 'auto' }}>
                  <div style={{ 
                    background: 'rgba(128,0,0,0.2)', 
                    padding: '1.5rem', 
                    borderRadius: '12px',
                    border: '1px solid var(--dark-red)',
                    marginBottom: '1.5rem'
                  }}>
                    <p style={{ 
                      color: 'var(--text-light)', 
                      margin: 0,
                      fontSize: '1rem',
                      fontFamily: 'monospace'
                    }}>
                      <span style={{ color: 'var(--gold)' }}>john.zpost.eth</span> → <span style={{ color: 'var(--gold)' }}>mary.zpost.eth</span>
                    </p>
                    <p style={{ 
                      color: 'var(--text-secondary)', 
                      margin: '0.5rem 0 0 0',
                      fontSize: '0.9rem',
                      fontStyle: 'italic'
                    }}>
                      This is how decentralized messaging works
                    </p>
                  </div>
                  
                  <a href="https://zpost.ai/zhat" target="_blank" rel="noopener noreferrer" className="btn btn-gold" style={{ 
                    padding: '1rem 3rem', 
                    fontSize: '1.1rem', 
                    fontWeight: 'bold',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem',
                    width: '100%'
                  }}>
                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                    Launch Zhat Messenger
                  </a>
                </div>
              </div>
            </div>

            {/* Right Image - mary1.png */}
            <div style={{ flex: 1, minWidth: '300px', textAlign: 'center' }}>
              <div style={{ 
                background: 'linear-gradient(135deg, var(--card-bg) 0%, rgba(0,0,0,0.5) 100%)', 
                border: '3px solid var(--gold)', 
                borderRadius: '15px', 
                padding: '1rem', 
                boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 30px rgba(255,215,0,0.3)',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Golden frame effect */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  border: '1px solid rgba(255,215,0,0.3)',
                  borderRadius: '12px',
                  pointerEvents: 'none',
                  zIndex: 2
                }}></div>
                
                {/* Image Container - EXACTLY LIKE MyUrl SECTION */}
                <div style={{ 
                  width: '500px', 
                  maxWidth: '100%',
                  height: '375px',
                  maxHeight: '375px',
                  borderRadius: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto', 
                  overflow: 'hidden', 
                  position: 'relative',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  border: '2px solid var(--gold)',
                  boxShadow: '0 8px 24px rgba(255,215,0,0.2)'
                }}>
                  {/* Mary Magdalene Image - EXACT SAME STYLE AS MyUrl SECTION */}
                  <img 
                    src="/mary1.png" 
                    alt="Mary Magdalene Zhat Interface" 
                    style={{ 
                      width: '500px',
                      height: '375px',
                      objectFit: 'contain', // CRITICAL: Same as MyUrl section
                      borderRadius: '10px',
                    }} 
                  />
                </div>
                
                {/* Image caption */}
                <div style={{ 
                  marginTop: '1.5rem',
                  padding: '1rem',
                  background: 'rgba(0,0,0,0.7)',
                  borderRadius: '8px',
                  border: '1px solid var(--border)'
                }}>
                  <h4 style={{ color: 'var(--gold)', marginBottom: '0.5rem', fontSize: '1.1rem' }}>
                    <FontAwesomeIcon icon={faComments} style={{ marginRight: '0.5rem' }} />
                    ENS Contacts
                  </h4>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                    Chat with any .eth domain holder directly
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Features */}
          <div style={{ 
            marginTop: '4rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem'
          }}>
            <div style={{ 
              textAlign: 'center',
              padding: '2rem',
              background: 'rgba(0,0,0,0.4)',
              borderRadius: '12px',
              border: '1px solid var(--border)'
            }}>
              <div style={{ color: 'var(--gold)', fontSize: '2rem', marginBottom: '1rem' }}>
                <FontAwesomeIcon icon={faShieldAlt} />
              </div>
              <h4 style={{ color: 'var(--text-light)', marginBottom: '0.5rem' }}>Zero Knowledge</h4>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                Even we can't read your messages
              </p>
            </div>

            <div style={{ 
              textAlign: 'center',
              padding: '2rem',
              background: 'rgba(0,0,0,0.4)',
              borderRadius: '12px',
              border: '1px solid var(--border)'
            }}>
              <div style={{ color: 'var(--gold)', fontSize: '2rem', marginBottom: '1rem' }}>
                <FontAwesomeIcon icon={faPaperPlane} />
              </div>
              <h4 style={{ color: 'var(--text-light)', marginBottom: '0.5rem' }}>Instant Delivery</h4>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                Real-time Web3 messaging protocol
              </p>
            </div>

            <div style={{ 
              textAlign: 'center',
              padding: '2rem',
              background: 'rgba(0,0,0,0.4)',
              borderRadius: '12px',
              border: '1px solid var(--border)'
            }}>
              <div style={{ color: 'var(--gold)', fontSize: '2rem', marginBottom: '1rem' }}>
                <FontAwesomeIcon icon={faLock} />
              </div>
              <h4 style={{ color: 'var(--text-light)', marginBottom: '0.5rem' }}>Registration</h4>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                Your .Zhat.eth domain is your identity
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BankSystem.co Section - KEPT INTACT */}
      <section className="features" style={{ padding: '4rem 2rem' }}>
        <div className="container">
          <div className="cards" style={{ display: 'flex', alignItems: 'center', gap: '3rem', maxWidth: '1200px', margin: '0 auto', flexDirection: 'row-reverse' }}>
            <div style={{ flex: 1 }}>
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div className="gold-logo" style={{ fontSize: '2.5rem' }}>BankSystem</div>
                  <span style={{ color: 'var(--gold)', fontWeight: 'bold', background: 'rgba(255,215,0,0.1)', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', fontFamily: 'monospace' }}>
                    banksystem.eth
                  </span>
                </div>
                <h2 style={{ fontSize: '2.2rem', color: 'var(--text-light)', marginBottom: '1rem', lineHeight: '1.2' }}>
                  BankSystem.eth Rocks DeFi: Cut Costs, AI Power, Freedom for Every Wallet!
                </h2>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '2rem' }}>
                  Comprehensive financial services powered by blockchain technology and $ENS Domains on Ethereum. 
                  Your complete Web3 banking solution with AI-powered insights and military-grade security.
                </p>
                <div style={{ background: 'rgba(255,215,0,0.05)', padding: '1.5rem', borderRadius: '12px', border: '1px solid var(--border)', marginBottom: '2rem' }}>
                  <h3 style={{ color: 'var(--gold)', marginBottom: '1rem' }}>Core Features:</h3>
                  <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem' }}>
                    <li>ENS Identity with .xbsys.eth domains</li>
                    <li>BankSystem Wallet with military-grade encryption</li>
                    <li>Real-time portfolio tracking with USD values</li>
                    <li>ETH and ERC-20 token management</li>
                    <li>AI-powered financial insights</li>
                    <li>Multi-wallet management with seed phrase backup</li>
                    <li>Transaction history with Etherscan integration</li>
                  </ul>
                </div>
              </div>
              <a href="https://banksystem.co" target="_blank" rel="noopener noreferrer" className="btn btn-gold" style={{ padding: '1rem 2.5rem', fontSize: '1.1rem', fontWeight: 'bold' }}>
                <FontAwesomeIcon icon={faUniversity} style={{ marginRight: '0.5rem' }} />
                Explore BankSystem.co
              </a>
            </div>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <div style={{ 
                background: 'linear-gradient(135deg, var(--card-bg) 0%, #0a0a0a 100%)', 
                border: '1px solid var(--gold)', 
                borderRadius: '15px', 
                padding: '1.5rem', 
                boxShadow: '0 20px 60px rgba(0,0,0,0.5), 0 0 20px var(--gold-shadow)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                {/* Image Container - Updated to 800x600 pixels */}
                <div style={{ 
                  width: '800px', 
                  maxWidth: '100%', // Responsive: will shrink on smaller screens
                  height: '600px',
                  maxHeight: '600px',
                  borderRadius: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto', 
                  overflow: 'hidden', 
                  position: 'relative',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  border: '2px solid var(--gold)',
                  boxShadow: '0 8px 24px rgba(255,215,0,0.2)'
                }}>
                  {/* Mary Magdalene Image - Updated to 800x600 pixels */}
                  <img 
                    src="/mary.png" 
                    alt="mary magdalene with flower" 
                    style={{ 
                      width: '800px', 
                      height: '600px',
                      objectFit: 'contain', // Shows full image without cropping
                      borderRadius: '10px',
                    }} 
                  />
                  {/* Overlay with BankSystem branding */}
                  <div style={{ 
                    position: 'absolute', 
                    bottom: '0', 
                    left: '0', 
                    right: '0', 
                    background: 'linear-gradient(to top, rgba(0,0,0,0.85), transparent 70%)',
                    padding: '1.5rem 2rem',
                    textAlign: 'center'
                  }}>
                    <div className="gold-logo" style={{ 
                      fontSize: '2.2rem', 
                      marginBottom: '0.5rem', 
                      textShadow: '0 2px 8px rgba(0,0,0,0.9)',
                      fontWeight: 'bold'
                    }}>BankSystem</div>
                    <p style={{ 
                      color: 'var(--text-light)', 
                      fontSize: '1rem', 
                      marginBottom: '1rem', 
                      textShadow: '0 1px 4px rgba(0,0,0,0.9)',
                      fontStyle: 'italic'
                    }}>Decentralized Finance Platform</p>
                    <div style={{ 
                      display: 'inline-block', 
                      padding: '0.6rem 1.2rem', 
                      background: 'rgba(128,0,0,0.8)', 
                      borderRadius: '8px', 
                      border: '1px solid var(--gold)',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.5)'
                    }}>
                      <p style={{ 
                        color: 'var(--gold)', 
                        margin: 0, 
                        fontFamily: 'monospace', 
                        fontSize: '0.95rem', 
                        fontWeight: 'bold',
                        letterSpacing: '0.5px'
                      }}>yourname.xbsys.eth</p>
                    </div>
                  </div>
                </div>
                <p style={{ 
                  color: 'var(--text-secondary)', 
                  marginTop: '1rem', 
                  fontSize: '0.9rem',
                  fontStyle: 'italic'
                }}>
                  Your complete Web3 banking ecosystem powered by AI
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MyUrl Section */}
      <section id="myurl" className="comparison" style={{ padding: '4rem 2rem', background: 'linear-gradient(135deg, var(--card-bg) 0%, rgba(255,215,0,0.05) 100%)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto 3rem' }}>
            <h2 style={{ fontSize: '2.8rem', color: 'var(--gold)', marginBottom: '1.5rem' }}>Get your own Web3 domain, keep it private!</h2>
            <p style={{ fontSize: '1.1rem', color: 'var(--text-secondary)', lineHeight: '1.6' }}>
              Web3 is changing how we think about owning stuff online and who we are in the digital space. 
              It's not like the old school centralized systems where big companies control everything. 
              Now, it's all about a peer-to-peer setup where you're in charge of your own digital territory.
            </p>
            <p style={{ fontSize: '1.1rem', color: 'var(--text-secondary)', lineHeight: '1.6', marginTop: '1rem' }}>
              At the heart of this shift is blockchain tech, which links your domain to this secure ledger 
              where everything's clear, real, and totally yours. As we move away from those centralized 
              power structures, a fresh way of registering domains is popping up, giving everyone the 
              chance to claim their own bit of the internet, no middlemen needed.
            </p>
          </div>

          <div className="cards" style={{ display: 'flex', alignItems: 'center', gap: '3rem', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ flex: 1 }}>
              <div style={{ background: 'linear-gradient(135deg, var(--card-bg) 0%, rgba(0,0,0,0.3) 100%)', border: '1px solid var(--gold)', borderRadius: '15px', padding: '2rem', boxShadow: '0 20px 60px rgba(0,0,0,0.5), 0 0 20px var(--gold-shadow)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                  <div className="gold-logo" style={{ fontSize: '2.5rem' }}>.MyUrl</div>
                  <span style={{ color: 'var(--gold)', fontWeight: 'bold', background: 'rgba(255,215,0,0.1)', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem' }}>
                    Top-Level Domain
                  </span>
                </div>
                <h3 style={{ color: 'var(--text-light)', fontSize: '1.8rem', marginBottom: '1rem' }}>Exclusive Top-Level Domains</h3>
                <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                  The .MyUrl TLD is all about embracing Web3 innovation, giving a cool space for those 
                  who are pushing the boundaries where decentralized tech meets new digital worlds.
                </p>
                <div style={{ background: 'rgba(255,215,0,0.05)', padding: '1rem', borderRadius: '8px', border: '1px solid var(--border)', marginBottom: '1.5rem' }}>
                  <p style={{ color: 'var(--gold)', fontWeight: 'bold', margin: 0, fontSize: '1rem' }}>
                    <FontAwesomeIcon icon={faChartLine} style={{ marginRight: '0.5rem' }} />
                    "URL" racks up a whopping twenty-five billion hits on Google. That's just a ton of links!
                  </p>
                </div>
                <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>
                  All powered by the Handshake Protocol.
                </p>
                <a href="https://www.namecheap.com/domains/registration/results/?domain=yourname.myurl&hns=true" target="_blank" rel="noopener noreferrer" className="btn btn-gold" style={{ width: '100%', padding: '1rem', fontSize: '1.1rem', fontWeight: 'bold' }}>
                  <FontAwesomeIcon icon={faGlobe} style={{ marginRight: '0.5rem' }} />
                  Register on Namecheap.com
                </a>
              </div>
            </div>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <div style={{ 
                background: 'linear-gradient(135deg, var(--card-bg) 0%, #0a0a0a 100%)', 
                border: '1px solid var(--gold)', 
                borderRadius: '15px', 
                padding: '1.5rem', 
                boxShadow: '0 20px 60px rgba(0,0,0,0.5), 0 0 20px var(--gold-shadow)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                {/* Image Container - Exactly 800x600 pixels */}
                <div style={{ 
                  width: '800px', 
                  maxWidth: '100%', // Responsive: will shrink on smaller screens
                  height: '600px',
                  maxHeight: '600px',
                  borderRadius: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto', 
                  overflow: 'hidden', 
                  position: 'relative',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  border: '2px solid var(--gold)',
                  boxShadow: '0 8px 24px rgba(255,215,0,0.2)'
                }}>
                  {/* John Connor Image - Exact dimensions */}
                  <img 
                    src="/john.png" 
                    alt="John Connor" 
                    style={{ 
                      width: '800px', 
                      height: '600px',
                      objectFit: 'contain', // Shows full image without cropping
                      borderRadius: '10px',
                    }} 
                  />
                </div>
                <p style={{ 
                  color: 'var(--gold)', 
                  marginTop: '1rem', 
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  fontStyle: 'italic',
                  textShadow: '0 1px 3px rgba(255,215,0,0.3)'
                }}>
                  Your Web3 Identity • Handshake Protocol
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* ADD Footer HERE - Right at the bottom of the page */}
      <Footer />
    </div>
  );
};

export default LandingPage;
